import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

const pendingRequests = new Map<string, Promise<any>>();

function serializeParams(params: any) {
  try {
    if (!params) return '';
    return JSON.stringify(params, Object.keys(params).sort());
  } catch (e) {
    return String(params);
  }
}

const originalGet = api.get.bind(api);

api.get = function (url: string, config?: any) {
  const paramsKey = serializeParams(config?.params);
  const key = `GET::${url}::${paramsKey}`;

  if (pendingRequests.has(key)) {
    return pendingRequests.get(key) as Promise<any>;
  }

  const promise = originalGet(url, config)
    .then((res: any) => {
      pendingRequests.delete(key);
      return res;
    })
    .catch((err: any) => {
      pendingRequests.delete(key);
      return Promise.reject(err);
    });

  pendingRequests.set(key, promise);
  return promise;
} as any;

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const isUnauthorized401 = status === 401;

    if (isUnauthorized401) {
      error._skipToast = true;
    }

    return Promise.reject(error);
  }
);

export default api; 